import React, {Component} from 'react';
import VettrisHeader from '../../components/VettrisHeader'
import Breakpoints from '../../utils/breakpoints'
import contentfulData from '../../../contentfuldata/data.json';
import Radium from 'radium';
import {StyleRoot} from 'radium';
import VettrisFooter from '../../components/VettrisFooter';
import VettrisArticle from '../../components/VettrisArticle';
import {prettifyUrl, getLang, eventDispatch} from '../../utils/util-functions';
import Colors from '../../utils/colors';
import MenuTabs from '../../components/MenuTabs'
import Breadcrumbs from '../../components/Breadcrumbs';
import Heroimage from '../../components/Heroimage'
import _ from 'lodash';

export class IndexPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      searchString: {menu: ""},
      path: ""
    };
    this.changeUrl = this.changeUrl.bind(this);
  }

  changeUrl (type){
    this.props.history.push('/'+this.state.path+'/#menu='+type);
    this.setState({
      searchString: {menu: type}
    });
    eventDispatch('hashchange');
  }

  componentDidMount() {
    setTimeout(() => { document.body.scrollTop = 0;}, 2);
    const brand = getLang();
    const menuTabs = _.orderBy(contentfulData.recruitmentMenuData[brand].recruitmentMenuData, ['type'], ['desc'] );

    this.setState({
      path: location ? location.pathname.split('/').filter((strPiece) => strPiece.length>1) : "",
      searchString: window.location.hash ? window.location.hash.split("=")[1] : ""
    }, () => {
      if (!this.state.searchString.menu && this.state.path!==""){
        this.props.history.push('/'+this.state.path+'/#menu='+prettifyUrl(menuTabs[0].type));
        this.setState({
          path: location ? location.pathname.split('/').filter((strPiece) => strPiece.length>1) : "",
          searchString: window.location.hash ? {menu: window.location.hash.split("=")[1]} : ""
        });
      }
    });
  }

  render() {

    const brand = getLang();
    const menuTabs = _.orderBy(contentfulData.recruitmentMenuData[brand].recruitmentMenuData, ['type'], ['desc'] );
    const aboutData = contentfulData.recruitmentData[brand].recruitmentData;
    const heroText = contentfulData.singleData[brand].singleData.frontpageHeroText;
    const heroImage = contentfulData.singleData[brand].singleData.recruitmentHeroImage.fields.file ? contentfulData.singleData[brand].singleData.recruitmentHeroImage.fields.file.url : "";
    const dataFromUrl = _.find(aboutData, item => prettifyUrl(item.menu.fields.type)===this.state.searchString.menu) || {};
    const heroImageColor = "#ffffff";
    return (
        <div>
          <VettrisHeader history={this.props.history}/>
          <Heroimage url={heroImage} heroText={heroText} color={heroImageColor}/>
            <StyleRoot>
              <div style={styles}>
                <div className="row">
                  <MenuTabs items={menuTabs} activeMenu={this.state.searchString.menu} clickFunc={this.changeUrl} />
                  <div className="col-xs-12">
                    <Breadcrumbs />
                  </div>
                </div>
                <div className="row recruitmentPage">
                  <div className="col-sm-12" style={styles.mobileDivider}></div>
                  <div className="col-xs-12" style={styles.mobileArticles}>
                    { Object.getOwnPropertyNames(dataFromUrl).length!==0 &&
                      <VettrisArticle article={dataFromUrl} history={this.props.history}/>
                    }
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </StyleRoot>
          <VettrisFooter />
        </div>
    )
  }
}

export default Radium(IndexPage)

const styles = {
  width: '100%',
  margin: '0 auto',
  [Breakpoints.media.siteOverMaxWidth]: {
    width: Breakpoints.width.site
  },
  mobileArticles: {
    [Breakpoints.media.siteUnderPadWidth]: {
      paddingLeft: 30,
      paddingRight: 30
    }
  },
  firstRow: {
    marginTop: Breakpoints.componentDivider
  },
  divider: {
    marginTop: 20
  },
  singleArticle: {
    marginTop: 20,
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    marginLeft: 20,
    paddingLeft: 0
  },
  typeContainer: {
    paddingRight: 40,
  },
  dividerSingleItem: {
    borderBottom: 'solid black 1px',
    marginTop: 20,
    paddingTop: 20,
    paddingBottom: 20,
  },
  singleArticleLink: {
    textDecoration: 'none',
    color: Colors.darkBlue
  },
  mobileDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  }
};


// WEBPACK FOOTER //
// ./src/pages/recruitment/index.js